import React, { useState } from 'react';
import { HiEye, HiEyeOff } from 'react-icons/hi';
import Check from '../../../assets/images/Check.png';
// import Error from '../../../assets/images/Error.png';
import InputMask from 'react-input-mask';
import { displayErrorMessage, displayKudzuplusErrorMessage, ValidationIcon } from '../../../utils';
import { ref } from 'yup';
// import Showpassword from '../../../assets/images/showpassword.png'
import Hidepassword from '../../../assets/images/hidepassword.png'
import upload from '../../../assets/images/Upload.png'
import uploadDisabled from '../../../assets/images/UploadDisabled.png'
import { useSelector } from 'react-redux';
import { appTheme } from '../../../helpers/utils/Utils';
import { t } from 'i18next';
import { BorderStyles, InputStyles } from 'utils/constants';
import FieldLabel from '../FieldLabel';

const CustomInput = ({ usernameText, name, placeholder, label, textInputValue, upgradeInputBg, value, register, error, type, onKeyPress, options, onChange, isValid, onClick, maxLength, isPasswordShow = false, isErrorShow = true, onKeyDownFun, autoFocus, isvalidImagehide, onBlur, onFocus, multiple, disabled, additionalStyle = '', readOnly = false, kudzuPlus, autoFill = false, showValidity = false, required, textColor, isDisabled = false }) => {
    const isSuccess = !error; // Assuming error is a boolean indicating success or failure
    const [showPassword, setShowPassword] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [inputValueLen, setInputValueLen] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const isFromSmiOne = useSelector((state) => state.fromSmiOne);
    const signUpkudzuPlusTrue = useSelector(state => state.isSignUpKudzuplusTrue);
    const appThemeData = appTheme(kudzuPlusTrue ? kudzuPlusTrue : signUpkudzuPlusTrue ? signUpkudzuPlusTrue : false);

    //const placeholderText = 'Enter Value';
    //styles for input
    const inputContainerClass = isPasswordShow ? " items-center" : " items-center";
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    // const handleKeyDown = (e) => {
    //   if (e.key === 'Enter') {
    //     e.preventDefault();
    //     e.stopPropagation();
    //   }
    // };
    // Function to format the input value as "999-999-999"
    const formatInput = (value) => {
        //  debugger;
        // Remove any non-numeric characters
        const numericValue = value.replace(/\D/g, '');

        // Add hyphens after every three characters
        let formattedValue = '';
        for (let i = 0; i < numericValue.length; i++) {
            formattedValue += numericValue[i];
            if ((i + 1) % 3 === 0 && i !== numericValue.length - 1) {
                formattedValue += '-';
            }
        }

        return formattedValue.slice(0, 9); // Limit the length to 9 characters
    };

    // Event handler for input changes
    const handleInputChange = (e) => {
        const newValue = formatInput(e.target.value);
        setInputValue(newValue);
    };

    const TextInputChange = (e) => {
        //debugger;
        const newValue = e.target.value;
        setInputValueLen(newValue.length);
    }

    const trimmedLabel = label?.trim();
    const trimmedName = name?.trim();
    const displayText = trimmedLabel || trimmedName;


    let inputElement;
    switch (type) {
        case 'text':
            const textRegister = register(name);
            inputElement = (
                <div className="w-full relative">
                    {displayText && (
                        <FieldLabel
                            name={name}
                            label={displayText}
                            textColor={textColor}
                            required={required}
                        />
                    )}

                    <div className="items-center">
                        <input
                            name={name}
                            type="text"
                            id={name}
                            {...textRegister}
                            className={`custom-autofill-input text-[#2965FB] caret-[#2965FB] ${InputStyles(isDisabled)}  ${additionalStyle} ${BorderStyles(error && isErrorShow, kudzuPlusTrue)} `}
                            autoComplete={autoFill ? "on" : "off"}
                            aria-autocomplete="none"
                            placeholder={placeholder}
                            onChange={(e) => { textRegister.onChange(e); onChange && onChange(e); }}
                            value={value}
                            defaultValue={textInputValue !== undefined ? textInputValue : ''}
                            onKeyDown={onKeyDownFun}
                            onKeyUp={TextInputChange}
                            maxLength={maxLength !== undefined ? maxLength : '50'}
                            autoFocus={autoFocus}
                            readOnly={readOnly}
                            disabled={isDisabled}
                            onKeyPress={onKeyPress}
                            onBlur={(e) => { setIsFocused(false); textRegister.onBlur(e); onBlur && onBlur(e); }}
                            onFocus={(e) => { setIsFocused(true); onFocus && onFocus(e); }}
                        />
                        {
                            usernameText && (
                                <p className="text-[#4B70B9] pt-2 lg:text-[14px] md:text-[14px] sm:text-[10px] text-[11px] font-hanken-grotesk font-[400] sm:font-medium  md:leading-[20px] leading-[17px]">
                                    {t("username_will_set")}
                                </p>
                            )
                        }

                        {showValidity && (
                            <div className="absolute right-[-2rem] bottom-5">
                                <ValidationIcon
                                    showValidity={showValidity}
                                    isFocused={isFocused}
                                    isValid={isValid}
                                    isErrorShow={isErrorShow}
                                    inputValueLen={inputValueLen}
                                    appThemeData={appThemeData}
                                    message={error}
                                />
                            </div>
                        )}
                    </div>
                </div>
            );
            break;
        case 'otp':
            const otpRegister = register(name);
            inputElement = (
                <div className="w-full relative">
                    {displayText && (
                        <FieldLabel
                            name={name}
                            label={displayText}
                            textColor={textColor}
                            required={required}
                        />
                    )}

                    <div className="items-center">
                        <input
                            name={name}
                            type="text"
                            inputMode="numeric"
                            id={name}
                            {...otpRegister}
                            className={`custom-autofill-input text-[#2965FB] caret-[#2965FB] ${InputStyles(isDisabled)} ${additionalStyle} ${BorderStyles(error && isErrorShow, kudzuPlusTrue)} `}
                            autoComplete={autoFill ? "on" : "off"}
                            aria-autocomplete="none"
                            placeholder={placeholder}
                            onChange={(e) => { otpRegister.onChange(e); onChange && onChange(e); }}
                            value={value}
                            defaultValue={textInputValue !== undefined ? textInputValue : ''}
                            onKeyDown={onKeyDownFun}
                            onKeyUp={TextInputChange}
                            maxLength={6}
                            autoFocus={autoFocus}
                            readOnly={readOnly}
                            onKeyPress={onKeyPress}
                            onBlur={(e) => { setIsFocused(false); otpRegister.onBlur(e); onBlur && onBlur(e); }}
                            onFocus={(e) => { setIsFocused(true); onFocus && onFocus(e); }}
                        />
                        {
                            usernameText && (
                                <p className="text-[#4B70B9] pt-2 lg:text-[14px] md:text-[14px] sm:text-[10px] text-[11px] font-hanken-grotesk font-[400] sm:font-medium  md:leading-[20px] leading-[17px]">
                                    {t("username_will_set")}
                                </p>
                            )
                        }

                        {showValidity && (
                            <div className="absolute right-[-2rem] bottom-5">
                                <ValidationIcon
                                    showValidity={showValidity}
                                    isFocused={isFocused}
                                    isValid={isValid}
                                    isErrorShow={isErrorShow}
                                    inputValueLen={inputValueLen}
                                    appThemeData={appThemeData}
                                    message={error}
                                />
                            </div>
                        )}
                    </div>
                </div>
            );
            break;
        case 'number':
            const numberRegister = register(name);
            inputElement = (
                <div className="w-full">
                    {displayText && (
                        <FieldLabel
                            name={name}
                            label={displayText}
                            textColor={textColor}
                            required={required}
                        />
                    )}
                    <div className="flex items-center">
                        <input
                            name={name}
                            type="number"
                            id={name}
                            {...numberRegister}
                            className={`${InputStyles(isDisabled)} ${BorderStyles((error && isErrorShow) || (showValidity && !isValid), kudzuPlusTrue)} `}
                            autoComplete="off"
                             placeholder={placeholder}
                            onChange={(e) => { numberRegister.onChange(e); onChange && onChange(e); }}
                            onKeyDown={(e) => {
                                if (e.target.value.length >= 6 && e.keyCode !== 8) {
                                    e.preventDefault();
                                }
                            }}
                            onBlur={(e) => { numberRegister.onBlur(e); onBlur && onBlur(e); }}
                        />
                    </div>
                </div>
            );
            break;
        case 'ssn_no':
            const ssnRegister = register(name);
            inputElement = (
                <div className="w-full">
                    <div className="flex items-center relative">
                        <button
                            type="button"
                            className="text-gray-500 absolute right-4 top-5 bg-transparent border-0 p-0 cursor-pointer"
                            onClick={togglePasswordVisibility}
                            aria-label={showPassword ? t('hide_password_alt') : t('show_password_alt')}
                        >
                            {!showPassword ? <img src={appThemeData.Showpassword} className='w-[20px] h-[20px]' alt="" /> : <img src={Hidepassword} className='w-[20px] h-[20px]' alt="" />}
                        </button>
                        <InputMask
                            //type="text"
                            mask='999-999-999'
                            maskChar="*"
                            id={name}
                            name={name}
                            {...ssnRegister}
                            // value={inputValue}
                             placeholder={placeholder}
                            onKeyDown={(event) => {
                                const input = event.target;
                                const currentValue = input.value.replace(/[^\d]/g, '');
                                if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
                                    event.preventDefault();
                                }
                            }}
                            className={`${InputStyles(isDisabled)} ${showPassword ? 'password-input' : ''}`}
                            autoComplete="off"
                            onChange={(e) => { ssnRegister.onChange(e); onChange && onChange(e); }}
                            onBlur={(e) => { ssnRegister.onBlur(e); onBlur && onBlur(e); }}

                        // onKeyUp={handleInputChange}
                        >
                        </InputMask>
                        {isValid === true ? (
                            <div className="ml-4"><img src={Check} size={20} alt="" /></div>
                        ) : (
                            isValid === false && <div className="ml-4"><img src={appThemeData.Error} size={20} alt="" /></div>
                        )}
                    </div>
                </div>

            );
            break;
        case 'dob':
            inputElement = (
                <div className="w-full">
                    {displayText && (
                        <FieldLabel
                            name={name}
                            label={displayText}
                            textColor={textColor}
                            required={required}
                        />
                    )}
                    <div className="flex items-center">
                        <input
                            name={name}
                            type="date"
                            id={name}
                            {...register(name)}
                            className={InputStyles(isDisabled)}
                            autoComplete="off"
                             placeholder={placeholder}
                            onChange={onChange}
                        />
                        {isValid === true ? (
                            <div className="ml-4"><img src={Check} size={20} alt="" /></div>
                        ) : (
                            isValid === false && <div className="ml-4"><img src={appThemeData.Error} size={20} alt="" /></div>
                        )}

                        {/* <DatePicker
          selected={selectedDate}
          onChange={onChange}
          dateFormat="yyyy-MM-dd"
          className={InputStyles}
          placeholderText={label}
          showMonthDropdown
          showYearDropdown
          id={name} 
          {...register(name)}
          value={value !== undefined ? value : ""} 
          dropdownMode="select" 
        /> */}
                        {isValid === true ? (
                            <div className="ml-4"><img src={Check} size={20} alt="" /></div>
                        ) : (
                            isValid === false && <div className="ml-4"><img src={appThemeData.Error} size={20} alt="" /></div>
                        )}
                    </div>
                </div>
            );
            break;
        case 'phone':
            inputElement = (
                <div className="w-full">
                    {displayText && (
                        <FieldLabel
                            name={name}
                            label={displayText}
                            textColor={textColor}
                            required={required}
                        />
                    )}
                    <div className="flex items-center">
                        <InputMask
                            name={name}
                            mask={`999-999-9999`}
                            id={name}
                            {...register(name)}
                            className={InputStyles(isDisabled)}
                            autoFocus={autoFocus}
                            onChange={onChange}
                             placeholder={placeholder}
                            onKeyDown={(event) => {
                                const input = event.target;
                                const currentValue = input.value.replace(/[^\d]/g, '');
                                if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
                                    event.preventDefault();
                                }
                            }}
                            onKeyUp={TextInputChange}
                            onBlur={onBlur}
                            autoComplete="off"
                            aria-autocomplete="none"
                        // autoComplete="new-password"
                        >
                        </InputMask>
                        {isValid === true ? (
                            <div className="ml-4"><img src={Check} size={20} alt="" /></div>
                        ) : (
                            isValid === false && inputValueLen > 0 && <div className="ml-4"><img src={appThemeData.Error} size={20} alt="" /></div>
                        )}
                    </div>
                </div>
            );
            break;
        case '6Code':
            const codeRegister = register(name);
            inputElement = (
                <div className="w-full code">
                    <div className="flex items-center space-x-4">
                        <input
                            name={name}
                            type={kudzuPlus || isFromSmiOne ? "password" : "text"}
                            inputMode="numeric"
                            // type="password"
                            id={name}
                            maxLength={6}
                            value={value}
                            {...codeRegister}
                            className={`font-hanken-grotesk placeholder:font-semibold placeholder:tracking-normal ${upgradeInputBg ? 'text-kudzu-blue' : 'text-[var(--btn-clr-cards-tabs)]'} text-left pl-3 py-2 ${upgradeInputBg ? 'placeholder-kudzu-blue' : 'placeholder-[var(--btn-clr-cards-tabs)]'} lg:text-sm md:text-[14px] sm:text-[14px] font-medium focus:outline-none w-full lg:h-[60px] md:h-[50px] sm:h-[45px] h-[50px] tracking-ultra-widest  ${upgradeInputBg ? 'bg-[#D6E2E8]' : 'bg-[var(--input-bg)]'} ${!kudzuPlusTrue ? 'border-2 border-[#DCDCD6]' : ''} focus:border-2 focus:border-[#4076FF] outline-none`}
                            autoComplete="off"
                             placeholder={placeholder}
                            onChange={(e) => { codeRegister.onChange(e); onChange && onChange(e); }}
                            autoFocus={autoFocus}
                            onKeyUp={TextInputChange}
                            onKeyPress={(e) => {
                                if (e.key < '0' || e.key > '9') {
                                    e.preventDefault();
                                }
                            }}
                            onBlur={(e) => { codeRegister.onBlur(e); onBlur && onBlur(e); }}
                            onFocus={(e) => { onFocus && onFocus(e); }}

                        // onKeyDown={(e) => {
                        //   if (e.target.value.length >= 6 && e.keyCode !== 8) {
                        //     e.preventDefault();
                        //   }
                        // }}
                        />
                    </div>
                </div>
            );
            break;
        // case 'phone':
        //   inputElement = (
        //     <div className="w-full">
        //       <div className="flex items-center">
        //         <InputMask
        //           mask='999-999-9999'
        //           id={name}
        //           {...register(name)}
        //           className={InputStyles}
        //           autoComplete="off"
        //           onChange={onChange}
        //           placeholder={placeholderText}
        //         >
        //         </InputMask>
        //         <div className="ml-4">
        //         {isValid === true ? (
        //           <div className="ml-4"><img src={Check} size={20} alt="Check" /></div>
        //         ) : (
        //           (isValid === false && inputValueLen > 0) && <div className="ml-4"><img src={Error} size={20} alt="Error" /></div>
        //         )}
        //         </div>
        //       </div>
        //     </div>
        //   );
        //   break;
        case 'checkbox':
            inputElement = (
                <div className="flex items-center">
                    <input
                        name={name}
                        type="checkbox"
                        id={name}
                        {...register(name)}
                        className="form-checkbox text-blue-500 h-4 w-4"
                    />
                    <label htmlFor={name} className="ml-2">{label}</label>
                </div>
            );
            break;
        case 'radio':
            inputElement = options.map((option) => (
                <div key={option.value} className="flex items-center">
                    <input
                        name={name}
                        type="radio"
                        {...register(name)}
                        value={option.value}
                        className="form-radio text-blue-500 h-4 w-4"
                    />
                    <label htmlFor={option.value} className="ml-2">{option.label}</label>
                </div>
            ));
            break;
        case 'dropdown':
            inputElement = (
                <div>
                    <FieldLabel
                        name={name}
                        label={displayText}
                        textColor={textColor}
                        required={required}
                    />
                   {/* <label htmlFor={name}>{label}</label>*/}
                    <select
                        name={name}
                        id={name}
                        {...register(name)}
                        className="font-hanken-grotesk w-full text-blue-500 px-4 py-2 bg-text-btn placeholder-kudzu-blue text-sm font-medium focus:outline-none"
                    >
                        {options.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>
            );
            break;
        case 'buttonGroup':
            inputElement = (
                <div>
                    <label>{label}</label>
                    <div className="flex">
                        {options.map((option) => (
                            <button
                                key={option.value}
                                type="button"
                                {...register(name)}
                                value={option.value}
                                className="px-4 py-2 mr-2 lg:text-[18px] md:text-[17px] 
                sm:text-[15px] text-[16px] font-medium bg-blue-500 text-white rounded-md focus:outline-none"
                            >
                                {option.label}
                            </button>
                        ))}
                    </div>
                </div>
            );
            break;
        case 'button':
        case 'submit':
            inputElement = (
                <>
                    <button
                        type={type}
                        className="font-hanken-grotesk lg:text-[18px] md:text-[17px] 
            sm:text-[15px] text-[16px] w-full bg-submit-btn hover:bg-submit-btn text-white py-2 px-4 md:font-[500] sm:font-[700] font-[500] lg:h-[60px] md:h-[50px] sm:h-[45px] h-[50px]"
                        onClick={onClick}
                        onKeyDown={onKeyDownFun}
                    >
                        {label}
                    </button>
                </>
            );
            break;
        case 'btn_withoutBg':
            inputElement = (
                <>
                    {/* <button
            type={type}
            className="font-hanken-grotesk w-full bg-submit-btn  text-white py-2 px-4 text-sm font-bold h-[60px]"
            onClick={onClick}
          >
            {label}
          </button>  */}
                    <button
                        type={type}
                        className="font-hanken-grotesk w-full bg-white border-submit-btn text-submit-btn py-2 px-4 text-sm border-2 border-btn-border  text-secondary-2 font-bold h-[60px]"
                        onClick={onClick}
                        onKeyDown={onKeyDownFun}
                    >
                        {label}
                    </button>
                </>
            );
            break;
        case 'password':
            const passwordRegister = register(name);
            const passwordHasError = isErrorShow && (error || (showValidity && !isValid));
            inputElement = (
                <div className="w-full relative">
                    {displayText && (
                        <FieldLabel
                            name={name}
                            label={displayText}
                            textColor={textColor}
                            required={required}
                        />
                    )}
                <div className={`${inputContainerClass} relative`}>
                        <input
                        name={name}
                        type={showPassword ? "text" : "password"}
                        id={name}
                        {...passwordRegister}
                        className={`${InputStyles(isDisabled)} ${BorderStyles(passwordHasError, kudzuPlusTrue)} `}
                        autoComplete="off"
                         placeholder={placeholder}
                        onChange={(e) => { passwordRegister.onChange(e); onChange && onChange(e); }}
                        autoFocus={autoFocus}
                        onKeyUp={TextInputChange}
                        onKeyDown={onKeyDownFun}
                        onBlur={(e) => { setIsFocused(false); passwordRegister.onBlur(e); onBlur && onBlur(e); }}
                        onFocus={(e) => { setIsFocused(true); onFocus && onFocus(e); }}

                    // onKeyDown={handleKeyDown}
                    />
                    {isPasswordShow !== false && inputValueLen > 0 && (
                        <span
                            type="button"
                            className="text-gray-500 ml-2 absolute md:right-4 right-4 top-5"
                            onClick={togglePasswordVisibility}
                        >
                            {!showPassword ? <img src={appThemeData.Showpassword} alt={t('show_password_alt')} /> : <img src={Hidepassword} className='w-[20px] h-[20px]' alt={t('hide_password_alt')} />}
                        </span>
                    )}

                    {showValidity && (isFocused ? (
                        <div className={`absolute right-[-2rem] bottom-5`}>
                            <img src={appThemeData.Pending} className="w-4 h-4" alt="" />
                        </div>
                    ) : showValidity && isValid ? (
                        <div className={`absolute right-[-2rem] bottom-5`}>
                            <img src={appThemeData.Check} className="w-4 h-4" alt="" />
                        </div>
                    ) : (
                        showValidity && !isValid && isErrorShow && <div className={`absolute right-[-2rem]  bottom-5 `}>
                            <img src={appThemeData.ExclamationError} className="w-4 h-4" alt="" /></div>
                    ))}
                    </div>
                </div>
            );
            break;

        case 'file':
            inputElement = (
                <div className="">
                    <input
                        name={name}
                        id={name}
                        type={type}
                        {...register(name)}
                        className="hidden"
                        onChange={onChange}
                        multiple={multiple}
                        disabled={disabled}
                    />
                </div>
            );
            break;
        default:
            inputElement = null;
    }

    return (
        <div className="mb-4">
            {inputElement}
            {(['text', 'checkbox', 'dropdown', 'buttonGroup', 'password', 'number', 'dob', 'ssn_no'].includes(type) && isErrorShow) && (
                // <div style={{ height: '1rem' }}>
                //   {error && <span className="text-red-500">{error.message}</span>}
                // </div>
                <div className='my-2 mt-4 md:w-[440px] sm:w-[213px]'>
                    {kudzuPlusTrue ? error && error.message && displayKudzuplusErrorMessage(error.message) : error && error.message && displayErrorMessage(error.message)}

                </div>
            )}
        </div>
    );
};

export default CustomInput;